import React, { useState } from 'react';
import '../App.scss';
import FooterBar from './FooterBar';
import checkScoreAPI from '../helpers/checkScoreAPI';

const ScoreChecker: React.FC = () => {
  const [email, setEmail] = useState('');
  const [score, setScore] = useState<number | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCheckScore = async () => {
    setError('');
    setScore(null);
    setLoading(true);

    // Validacija unosa email adrese
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setLoading(false);
      setError('Unesite validnu email adresu.');
      return;
    }

    try {
      const response = await checkScoreAPI(email);

      if (response && typeof response === 'object' && 'score' in response) {
        setScore(response.score);
      } else {
        setError('Nije moguće dobiti rezultat. Pokušajte ponovo.');
      }
    } catch (err) {
      console.error('Greska:', err);
      setError('Došlo je do greške. Molimo pokušajte ponovo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <form className="form" onSubmit={(e) => e.preventDefault()}>
        <h2>Proverite svoj ukupan rezultat</h2>
        <label htmlFor="email">Unesite svoj email:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="vas@email.com"
        />
        {error && <p className="error">{error}</p>}
        <button
          type="button"
          className="submit-button"
          onClick={handleCheckScore}
          disabled={loading}
        >
          {loading ? 'Provera je u toku...' : 'Provera'}
        </button>
        {score !== null && (
          <p className="success">
            Vaš rezultat je: <br />  <span className="score-value">{score}</span> poena
          </p>
        )}
      </form>
      <FooterBar />
    </div>
  );
};

export default ScoreChecker;
